// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hmZI","type":"styles_type__15IBW","choices":"styles_choices__3s1pZ"};